import AOS from "aos";

AOS.init({
	duration: 1000
});
